import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import {
  RQ_BLOG_ARTICLES,
  RQ_BLOG_ARTICLE,
} from '@/modules/ReactQuery/cacheKeys';
import { ARTICLES_PER_PAGE } from '@/modules/blog/constants';
import { getBlogArticle } from '@/modules/blog/helpers/getBlogArticle';
import { getBlogArticles } from '@/modules/blog/helpers/getBlogArticles';

export function blogArticlesInfiniteQueryOptions(initialPageParam: number) {
  return infiniteQueryOptions({
    queryKey: [RQ_BLOG_ARTICLES],
    queryFn: ({ pageParam: skip }) => {
      return getBlogArticles({ limit: ARTICLES_PER_PAGE, skip });
    },
    getNextPageParam: (_, allPages) => {
      return allPages.flatMap((articles) => articles || []).length;
    },
    initialPageParam,
  });
}

export function blogArticleQueryOptions(slug: string) {
  return queryOptions({
    queryKey: [RQ_BLOG_ARTICLE, slug],
    queryFn: () => getBlogArticle(slug),
  });
}
